const mapping = {
  groupName: "like",
  owner: "like",
  createdAt: "gte,lte",
  name: "like",
  userName: "like",
  email: "like",
  id: "in",
  vmetaGroupId: "in",
};

export const createFilterQuery = (
  filter: Array<{ id: string; value: any }>
) => {
  const query = filter.map(f => {
    const { id, value } = f;
    const type = mapping[id];
    if (type === "like") {
      return `${id}:${type}=${value}`;
    }
    if (type === "in") {
      if (Array.isArray(value)) {
        return `${id}:${type}=${value.join(";")}`;
      } else {
        return `${id}:${type}=${value}`;
      }
    }
    if (type === "gte,lte") {
      const [start, end] = type.split(",");
      return `${id}:${start}=${value.startDate},${id}:${end}=${value.endDate}`;
    }

    return "";
  });
  return query.join(",");
};
